<template>
<div class="container">
  <div class="center">
    <div class="nav-bar">
      <p>
        <span class="parent-link"  @click="navToHome()" >Admin</span>
        <span> >> </span>
        <span> {{title}} </span>
      </p>
    </div>
    <div class="operate">
      <div class='typeSelect'>
        <span>data type</span>
        <el-select v-model="dataType" @change="changeDadaType" placeholder="请选择" style="width: 150px;">
          <el-option
            v-for="item in dataTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="button">
        <el-button type="primary" class="btn" @click='showUploadDialog'>导入</el-button>
        <el-button type="primary" class="btn" @click='exportExcel' style="margin-right:20px"> 导出数据</el-button>
        <el-button type="primary" class="btn" @click='exportGraph' style="margin-right:20px"> 导出图表</el-button>
      </div>
    </div>
    <Upload
    v-on:uploadToServer = "uploadToServer"
    :dataType="dataType"
    ref="upload"
    ></Upload>
    <div>
    </div>
    <keep-alive>
      <component ref='child' :is="currentComponent"></component>
    </keep-alive>
  </div>
</div>
</template>
<script>
import Upload from './dataSTS/Upload.vue'
import insulinStatistics from './dataSTS/insulinStatistics.vue'
import HCLStatistics from './dataSTS/HCLStatistics.vue'
export default {
  components: {
    Upload,
    insulinStatistics,
    HCLStatistics
  },
  data(){
    return {
      currentComponent:'HCLStatistics',
      permission:'',
      title:'',
      dataType: 'HCL',
      componentMap:new Map([
        ['HCL', 'HCLStatistics'],
        ['Insulin', 'insulinStatistics']
      ]),
      dataTypeList:[
        {
          "value": "HCL",
          "label": "HCL statistics"
        },
        {
          "value": "Insulin",
          "label": "Insulin statistics"
        }
      ],
    }
  },
  methods:{
    navToHome() {
      this.$router.push('/accountsadmin_home')
    },
    uploadToServer(uploadData){
      this.$refs.upload.dialogVisible = false
      this.$refs.child.uploadToServer(uploadData)
    },
    // 导出列表
    exportExcel () {
      this.$refs.child.exportExcel()
    },
    // 导出图表
    exportGraph() {
      this.$refs.child.exportGraph()
    },
    changeDadaType() {
      this.currentComponent = this.componentMap.get(this.dataType)
    },
    showUploadDialog() {
      this.$refs.upload.dialogVisible = true
    },
  },
  mounted() {
    const permission = sessionStorage.getItem('account_admin_permission_value')
    const title = sessionStorage.getItem('account_admin_permission_title')
    this.permission = permission;
    this.title = title;
  }
}
</script>
<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .no-data {
    padding-top: 5%;
  }
  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }
  .container .center .nav-bar span{
    cursor: pointer;
  }
  .operate{
    display: flex;
    justify-content: space-between;
  }
  .button {
    display: flex;
    flex-flow: nowrap;
    justify-content: flex-end;
    margin-top: 25px;
  }
  .btn {
    background-color: #0c544fff;
    border-color: #0c544fff;
  }
  .typeSelect {
    margin-top: 25px;
  }
  >>> .el-select-dropdown__item.selected{
    background-color: #0c544fff;
  }
  >>> .el-select-dropdown__item.selected.hover{
    background-color: #0c544fff;
  }
</style>



// WEBPACK FOOTER //
// dataStatistics.vue?74d21578